import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { User } from "models";

const FormHelper = createFormHelper<User>();

export const StarStatusSection = () => {
  const { t } = useTranslation();

  return (
    <div className="setting_section role_order">
      <div>
        <h3 className="section-title">{t("v8_star_status", "Star Status")}</h3>

        <div className="FormSection">
          <Form.Group className="Star-container">
            <FormHelper.Field.Checkbox
              name="star_color_green_enabled"
              label={
                <label>
                  <Icon className="star star-green" />
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="star_color_blue_enabled"
              label={
                <label>
                  <Icon className="star star-blue" />
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="star_color_yellow_enabled"
              label={
                <label>
                  <Icon className="star star-yellow" />
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="star_color_red_enabled"
              label={
                <label>
                  <Icon className="star star-red" />
                </label>
              }
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
};
